import _ from 'lodash';
import { FILTER_TYPES } from 'common/constants/filters';

export const formatPmEntitiesByName = pmEntities => {
  return pmEntities.map(({ name = '' }) => ({
    id: name,
    title: name
  }));
};

export const formatSelectedFiltersToFilterMenus = ({ filters }) => {
  const {
    issue_types = [],
    labels = [],
    custom_fields = {},
    keywords = []
  } = filters;

  const formattedIssueTypes = issue_types.map(issueType => ({
    id: issueType,
    title: issueType
  }));
  const formattedLabels = labels.map(label => ({
    id: label,
    title: label
  }));
  const formattedKeywords = keywords.map(keyword => ({
    id: keyword,
    title: keyword
  }));

  const customFields = Object.keys(custom_fields).reduce((acc, fieldKey) => {
    const field = custom_fields[fieldKey] || {};
    const fieldValues = field.values || [];

    const fieldFormatted = !!fieldValues.length
      ? {
          [fieldKey]: fieldValues.map(value => ({
            id: value,
            title: value
          }))
        }
      : {};
    return {
      ...acc,
      ...fieldFormatted
    };
  }, {});

  const formattedSelectedFilters = {
    ...(!!issue_types.length && {
      [FILTER_TYPES.ISSUE_TYPES]: formattedIssueTypes
    }),
    ...(!!labels.length && { [FILTER_TYPES.LABEL]: formattedLabels }),
    ...(!!keywords.length && { [FILTER_TYPES.KEYWORDS]: formattedKeywords }),
    ...customFields
  };

  return formattedSelectedFilters;
};

export const formatFilterMenusFiltersToStateFilters = ({
  filters,
  customFieldsMapper
}) => {
  const issue_types = (filters[FILTER_TYPES.ISSUE_TYPES] || []).map(
    ({ title }) => title
  );
  const labels = (filters[FILTER_TYPES.LABEL] || []).map(({ title }) => title);
  const keywords = (filters[FILTER_TYPES.KEYWORDS] || []).map(
    ({ title }) => title
  );

  const customFields = _.omit(filters, [
    FILTER_TYPES.LABEL,
    FILTER_TYPES.ISSUE_TYPES,
    FILTER_TYPES.KEYWORDS
  ]);

  const formattedCustomFields = Object.keys(customFields).reduce(
    (acc, fieldKey) => {
      return {
        ...acc,
        [fieldKey]: {
          id: fieldKey,
          name: customFieldsMapper[fieldKey],
          values: customFields[fieldKey]
            .map(valueObj => valueObj?.title)
            .filter(Boolean)
        }
      };
    },
    {}
  );

  const formattedFilters = {
    ...(!!issue_types.length && { issue_types }),
    ...(!!labels.length && { labels }),
    ...(!!keywords.length && { keywords }),
    ...(!!_.size(formattedCustomFields) && {
      custom_fields: formattedCustomFields
    })
  };

  return formattedFilters;
};
